
import React from 'react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { useLanguage } from '@/contexts/LanguageContext';

interface ContributorsTooltipProps {
  contributors: string[];
  sampleSize: number;
  children: React.ReactNode;
}

const ContributorsTooltip: React.FC<ContributorsTooltipProps> = ({
  contributors,
  sampleSize,
  children
}) => {
  const { t } = useLanguage();
  const maxDisplayed = 10;
  const hasMore = contributors.length > maxDisplayed;
  const displayedContributors = contributors.slice(0, maxDisplayed);
  const remainingCount = contributors.length - maxDisplayed;

  return (
    <TooltipProvider>
      <Tooltip delayDuration={300}>
        <TooltipTrigger asChild>
          {children}
        </TooltipTrigger>
        <TooltipContent className="max-w-xs p-3" side="top">
          <div className="space-y-2">
            <h4 className="font-semibold text-sm">
              {t('profiles.contributors.title', { count: sampleSize }) || `Contributors (${sampleSize})`}
            </h4>
            <div className="space-y-1 max-h-32 overflow-y-auto">
              {displayedContributors.map((name, index) => (
                <div key={index} className="text-xs text-gray-600">
                  • {name}
                </div>
              ))}
              {hasMore && (
                <div className="text-xs text-gray-500 italic">
                  {t('profiles.contributors.andMore', { count: remainingCount }) || `and ${remainingCount} more...`}
                </div>
              )}
            </div>
          </div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default ContributorsTooltip;
